import { render, staticRenderFns } from "./MeusDados.vue?vue&type=template&id=d9fa2fe4"
import script from "./MeusDados.vue?vue&type=script&lang=js"
export * from "./MeusDados.vue?vue&type=script&lang=js"
import style0 from "./MeusDados.vue?vue&type=style&index=0&id=d9fa2fe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports